@if (prestatie$ | async; as prestatie) {
  @if (client$ | async; as client) {
    <zah-client-header [client]="client"
      label="Stop prestatie">
    </zah-client-header>
    <div class="content">
      <zah-clientnummer-selector (clientnummerSelected)="stopPrestatie(prestatie, client, $event)"
        actieLabel="Stop">
        <div class="hint">Druk op STOP om de QR code te scannen en de prestatie te stoppen</div>
      </zah-clientnummer-selector>
      <button mat-mini-fab
        color="primary"
        class="back-button"
        (click)="navigateBack()">
        <mat-icon>arrow_back</mat-icon>
      </button>
    </div>
  }
}
